// ModalsLoader.jsx
import PropTypes from 'prop-types';

const isServer = typeof window === 'undefined';

const ModalsLoader = ({ isAnyModalOpened = false, children = null }) => {
  if (isServer || !isAnyModalOpened) {
    return null;
  }
  return children;
};

ModalsLoader.propTypes = {
  isAnyModalOpened: PropTypes.bool,
  children: PropTypes.object.isRequired,
};

export default ModalsLoader;
